import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Label-over-value field block used in Ventas info cards.
 *
 * When `loading` is true a shimmer bar replaces the value so the user can
 * tell the field is still being fetched. Once `loading` flips to false,
 * a trimmed-empty value falls back to an em-dash.
 */
export function InfoField({
  label,
  value,
  loading = false,
}: {
  label: string;
  value: string | null | undefined;
  loading?: boolean;
}) {
  return (
    <div className="flex flex-col">
      <span className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
      {loading ? (
        <Skeleton className="mt-1 h-4 w-24" />
      ) : (
        <span className="truncate text-sm text-foreground">{value?.trim() || '—'}</span>
      )}
    </div>
  );
}
